import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { TicketUserType } from '../models/ticketusertype';

@Injectable({
  providedIn: 'root'
})
export class EvoTicketUserTypeService {

  private baseApiUrl=environment.apiUrl;

  constructor(private httpClient:HttpClient) { }

  getList():Observable<TicketUserType[]>{
    return this.httpClient.get<TicketUserType[]>(this.baseApiUrl+'GetTicketUserTypeList');
  }

  getListByTicketId(id:number):Observable<TicketUserType[]>{
    return this.httpClient.get<TicketUserType[]>(this.baseApiUrl+'GetTicketUserTypeListByTicketId/'+id);
  }

  
  
}
